// extracted by mini-css-extract-plugin
export default {"titleBlock":"styles_titleBlock__HZyw6","title":"styles_title__HtIy4","arrow":"styles_arrow__dYnoc","dropDownBlock":"styles_dropDownBlock__B3XYU"};